/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class SubsidyApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/subsidyApply';
    }

    findSubsidyApplyList(queryData) {
        let examinationTimeBegin = null;
        let examinationTimeEnd = null;
        if (queryData.examinationTime != null && queryData.examinationTime.length === 2) {
            [examinationTimeBegin, examinationTimeEnd] = queryData.examinationTime;
        }
        return super.get('/findSubsidyApplyList', {
            ...queryData,
            examinationTimeBegin,
            examinationTimeEnd,
        });
    }

    getSubsidyApplyDetail({ id }) {
        return super.get('/getSubsidyApplyDetail', { id });
    }

    submit({ id, applyStatus, auditOpinion, notPassIds } = {}) {
        return super.post('/submit', {
            id,
            applyStatus,
            auditOpinion,
            notPassIds,
        });
    }

    cancel({ id } = {}) {
        return super.post('/cancel', {
            id,
        });
    }

    applyMaterialsAudit({ id, applyMaterialsIds, applyMaterialsStatus } = {}) {
        return super.post('/applyMaterialsAudit', {
            id,
            applyMaterialsIds,
            applyMaterialsStatus,
        });
    }

    applyMaterialsDetail({ subsidyApplyId, applyMaterialsId }) {
        return super.get('/applyMaterialsDetail', { subsidyApplyId, applyMaterialsId });
    }

    saveApplyMaterials({ subsidyApplyId, applyMaterialsId, applyMaterialsValue }) {
        return super.post('/saveApplyMaterials', { subsidyApplyId, applyMaterialsId, applyMaterialsValue });
    }

    editDeliveryInfo({
        id,
        shipMethod,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
        companyName,
        workRegionId,
    }) {
        return super.post('/editDeliveryInfo', {
            id,
            shipMethod,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            companyName,
            workRegionId,
        });
    }
}

export default new SubsidyApply();
export { SubsidyApply };
